import { axiosHandler } from "../lib/utils";
import * as Sentry from "@sentry/react";

/**
 * Approve a client using token
 * @param {string} token - Approval token
 * @returns {Promise} API response
 */
export const approveClient = (token) => async (_, getState) => {
  try {
    const json = await axiosHandler({
      url: `admin/client/approve/${token}`,
      method: "POST",
      state: getState(),
    });
    return json?.data;
  } catch (e) {
    Sentry.captureException(e);
    throw e;
  }
};

/**
 * Deny a client with optional comment
 * @param {string} token - Denial token
 * @param {string} comment - Optional denial reason
 * @returns {Promise} API response
 */
export const denyClient = (token, comment) => async (_, getState) => {
  try {
    const json = await axiosHandler({
      url: `admin/client/deny/${token}`,
      method: "POST",
      state: getState(),
      data: {
        comment,
      },
    });
    return json?.data;
  } catch (e) {
    Sentry.captureException(e);
    throw e;
  }
};
